import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useUser } from "../../context/UserContext.jsx";
import { Images } from "../Common/Images.jsx";
import { setAccessToken, setRefreshToken, setGuId, setImpersonated, hydrateProfileFromRecords, isValidStoredValue } from "../../utils/SecurityService.js";
import { Profile_api } from "../Login/LoginAPI.js";

function AutoLogin() {
  const history = useHistory();
  const { setUser } = useUser();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const atoken = params.get("atoken");
    const rtoken = params.get("rtoken");
    const uid = params.get("uid");
    // Reject junk tokens from the redirect URL (missing, empty, or the literal strings
    // "undefined"/"null"). Without this, a redirect like `?atoken=undefined&rtoken=undefined`
    // passes a plain length check and gets persisted, leaving a logged-in-looking session
    // with dead tokens that no refresh can recover.
    const isQueryAvailable = [atoken, rtoken, uid].every((param) => isValidStoredValue(param?.trim()));
    // Impersonation is opt-in: only the literal `impersonated=1` enables it. Anything else
    // (absent, empty, "0", junk) resolves to 0, and 0 is written on every auto-login so a
    // stale flag from a previous impersonated session can never survive into a normal one.
    const impersonated = params.get("impersonated")?.trim() === "1" ? 1 : 0;
    console.log("AutoLogin params:", { atoken, rtoken, uid, impersonated, isQueryAvailable });
    if (!isQueryAvailable) {
      window.setTimeout(() => history.replace("/login"), 1000);
      return;
    }

    const completeAutoLogin = async () => {
      try {
        setIsLoading(true);
        setAccessToken(atoken);
        setRefreshToken(rtoken);
        setGuId(uid);
        setImpersonated(impersonated);

        const response = await Profile_api({ GuId: uid });

        if (response?.Data?.ResponseCode !== 200) {
          const errorText = response?.Data?.ErrorMessage;
          throw new Error(errorText);
        }

        const records = response?.Data?.Records || {};

        hydrateProfileFromRecords(records);

        setUser({
          firstName: records?.FirstName || "",
          lastName: records?.LastName || "",
        });

        window.history.replaceState({}, document.title, window.location.pathname);
        history.replace("/calendar");
      } catch (error) {
        console.error("AutoLogin failed:", error);
        setIsLoading(false);
        window.setTimeout(() => history.replace("/login"), 2000);
      }
    };

    completeAutoLogin();
  }, [history, setUser]);

  return (
    <div className="autologin-page" style={{ padding: "24px", textAlign: "center" }}>
      {isLoading && (
        <div id="preloader">
          <img src={Images.LoaderFull} alt="Loading" />
        </div>
      )}
     <img src={Images.LogoBig} alt="Ronspot Logo" />
      
    </div>
  );
}

export default AutoLogin;
